import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_AD_56 } from "@/lib/programData";
export default function AtlasDesierto56Page() {
  return <ProgramTemplate program={PROGRAM_AD_56} variant="ad" showJourneyChronology />;
}
